/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/run.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Describes whether an entity is available or archived.
 *
 *  - STORAGE_STATE_UNSPECIFIED: Default state. This state in not used
 *  - AVAILABLE: Entity is available.
 *  - ARCHIVED: Entity is archived.
 * @export
 */
export const V2beta1RunStorageState = {
  STORAGE_STATE_UNSPECIFIED: 'STORAGE_STATE_UNSPECIFIED',
  AVAILABLE: 'AVAILABLE',
  ARCHIVED: 'ARCHIVED',
} as const;
export type V2beta1RunStorageState =
  (typeof V2beta1RunStorageState)[keyof typeof V2beta1RunStorageState];

export function instanceOfV2beta1RunStorageState(value: any): boolean {
  for (const key in V2beta1RunStorageState) {
    if (Object.prototype.hasOwnProperty.call(V2beta1RunStorageState, key)) {
      if (V2beta1RunStorageState[key as keyof typeof V2beta1RunStorageState] === value) {
        return true;
      }
    }
  }
  return false;
}

export function V2beta1RunStorageStateFromJSON(json: any): V2beta1RunStorageState {
  return V2beta1RunStorageStateFromJSONTyped(json, false);
}

export function V2beta1RunStorageStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V2beta1RunStorageState {
  return json as V2beta1RunStorageState;
}

export function V2beta1RunStorageStateToJSON(value?: V2beta1RunStorageState | null): any {
  return value as any;
}

export function V2beta1RunStorageStateToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): V2beta1RunStorageState {
  return value as V2beta1RunStorageState;
}
